import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { SharedServices } from '../../../../services/shared.services'
import { ModalService } from '../../../../services/modal.service'
import { notification } from 'onsenui'
import { identity, pickBy } from 'lodash'
import { Subject } from 'rxjs'

@Component({
    selector: 'app-modal-seting-staff-edit',
    templateUrl: './modal-staff-edit.component.html',
    styleUrls: ['../../../../stagingcss/root-ui-view.component.css', '../../../../stagingcss/main-body.component.css', '../../../../stagingcss/main-view.component.css', '../../../../stagingcss/lui-select.component.css', './modal-staff.component.css'],
})

export class ModalStaffEditComponent implements OnInit, OnDestroy {

    // style class update password modal staff
    oldStyle
    classPassStaff
    namePassStaff
    veryWeak = false
    // ************************** TASK STAFF
    hiddenModal = 'hidden'
    hiddenNewStaff = 'hidden'
    staffInfo: any = {}
    hasPasswordAuthentication: boolean = false
    arrClinic: object
    showClinic = 'hidden'
    staffForm: FormGroup
    doctor
    nameDoctor
    password
    cordinator
    firstName
    familyName
    userId
    nameCordinator
    administrator
    nameAdministrator
    confirmList = []
    confirmListId = []
    clinicIds
    clinics
    hasPassword
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    en = {}
    showEN = true
    statusESC = false
    dirtyButton = false
    modalChangeObserver$ = new Subject<boolean>()
    currentStaffId

    validUserIdUpdate = true
    validNameUpdate = true
    validPassWordUpdate = true
    valifFormUpdate = true
    isUserIdExist = false
    
    form_error_password_valid = ''
    form_error_userid_valid = ''
    formUserId=''
    isEnableSave = true
    isSaveStaff = false
    isEditStaff = true
    maxRank = 0
    isUserIdHalfWidthValid = true


    constructor(private _sharedService: SharedServices, private authData: AuthService, private restApi: RestServices, private formBuider: FormBuilder, private modalService: ModalService) {
    }

    ngOnInit() {
        this.modalService.changeEmitted$.takeUntil(this.modalChangeObserver$).subscribe(success => {
            if (success) {
                if (success[1] === 'active') {
                    this.hiddenNewStaff = 'active'
                    this.maxRank = success[0]
                    // hiden password Authentication
                    this.hasPassword = undefined
                    this.staffForm.reset()
                    this.hasPasswordAuthentication = false
                    this.getlistClinic()
                    this.staffForm.get('firstName').setValue('')
                    this.staffForm.get('familyName').setValue('')
                }
                if (success[1] === 'activeStaffEdit') {
                    this.getlistClinic()
                    this.hiddenModal = 'active'
                    this.getEditList(success[0])                    
                    this.confirmListId = []
                    this.confirmList = []
                }
                this.clinicIds = undefined
                this.clinics = undefined
                this.isSaveStaff = false
                this.isEditStaff = true
            }
        })
      
        
        this.validatorForm()
        this.currentStaffId = this.authData.getUser()['staffId']
    }

    ngOnDestroy(): void {
        if(this.modalChangeObserver$){
            this.modalChangeObserver$.next(true)
            this.modalChangeObserver$.unsubscribe()
        }
    }

    // ***************************************************** STAFF SETTING ***************************************************************//
    // style password
    stylePassword(lengthPassword, isFirstLoad = false) {
        if(!isFirstLoad){
            if (this.hasPassword) {
                lengthPassword = this.hasPassword.trim().length
            }
            if (lengthPassword < 8) {
                this.oldStyle = { height: '38px', padding: '0px', margin: 'auto 0px', width: 14 * lengthPassword + '%' }
            }
            if (lengthPassword <= 2) {
                this.classPassStaff = 'veryWeak'
                this.namePassStaff = this.en['app-setting-staff-veryweak']
                this.veryWeak = true
            }
            if (lengthPassword >= 3 && lengthPassword <= 7) {
                this.classPassStaff = 'weak'
                this.namePassStaff = this.en['app-setting-staff-weak']
                this.veryWeak = false
            }
            if (lengthPassword >= 10) {
                this.classPassStaff = 'strong'
                this.veryWeak = false
                this.namePassStaff = this.en['app-setting-staff-strong']
            }
            if (lengthPassword >= 15) {
                this.classPassStaff = 'verystrong'
                this.veryWeak = false
                this.namePassStaff = this.en['app-setting-staff-very-strong']
            }
        }
        
        this.validPassWord()
    }

    validPassWord(){
        if (this.staffForm.value.hasPasswordAuthentication) {            
            if(!this.staffForm.get('password').dirty){
                if (this.hasPassword) {
                    this.validPassWordUpdate = true
                } else {
                    this.validPassWordUpdate = false
                    this.form_error_password_valid = this.en['form-error-required']
                }
            } else {
                if(!this.staffForm.value.password || this.staffForm.value.password.trim() == '') {
                    this.validPassWordUpdate = false
                    this.form_error_password_valid = this.en['form-error-required']
                } else {
                const reg = new RegExp(/^[ -00-9:-@A-~]*$/)
                if (!this.staffForm.value.password.match(reg)) {
                    this.validPassWordUpdate = false
                    this.form_error_password_valid =this.en['form-error-password-valid']
                } else {
                    this.validPassWordUpdate = true
                }}
            }        
            this.checkEnableSave()

        }
    }

    checkEnableSave(){
        if(this.validUserIdUpdate && this.validPassWordUpdate){
            this.isEnableSave = true
        } else {
            this.isEnableSave = false
        }
    }


    validatorForm() {
        this.staffForm = this.formBuider.group({
            firstName: ['', Validators.required],
            familyName: ['', Validators.required],
            hasPasswordAuthentication: ['', Validators.required],
            userId: ['', Validators.required],
            password: ['', Validators.required],
            accessCounter: ['', Validators.required],
        })
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        let keyPressed = event.keyCode
        if (keyPressed === 27) {
            if (this.statusESC) {
                this.statusESC = false
                this.showClinic = 'hidden'
            } else {
                if (this.staffForm.dirty || this.dirtyButton) {
                    this.changeLanguage()
                    notification.confirm({
                        message: this.en['alert-content-discard'],
                        title: '<b>' + this.en['alert-discard'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], 'OK'],
                        callback: i => {
                            if (i === 1) {
                                this.hidenModal()
                            }
                        },
                    })
                } else {
                    this.hidenModal()
                }
            }
            event.preventDefault()
        }
    }

    // hiden modal
    hidenModal() {
        this.hiddenModal = 'hidden'
        this.hiddenNewStaff = 'hidden'
        this.hasPasswordAuthentication = undefined
        this.doctor = undefined
        this.cordinator = undefined
        this.administrator = undefined
        this.clinicIds = undefined
        this.clinics = undefined
        this.confirmList = []
        this.confirmListId = []
        this.hasPassword = undefined
        this.classPassStaff = undefined
        this.namePassStaff = undefined
        this.dirtyButton = false
        this.staffForm.reset()
        this.veryWeak = false

        this.validNameUpdate = true
        this.validUserIdUpdate = true
        this.validUserIdUpdate = true
        this.validPassWordUpdate = true
        this.isUserIdExist = false
        this.formUserId =''
        this.isEnableSave = true
        this.staffInfo ={}
        
    }

    // show modal clinic
    clickClinic() {
        this.statusESC = true
        this.getlistClinic()
        this.showClinic = 'active'
        this.confirmList = this.clinics ? [...this.clinics] : []
        this.confirmListId = this.clinicIds ? [...this.clinicIds] : []
    }

    // post api clinic
    getlistClinic() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.arrClinic = success['response']['clinic']['paths']['{}'] || null
            })
        })
    }

    // post api list edit staff
    getEditList(success) {
        const resourceUrl = 'resource'
        const map = {}
        map[success] = true
        const resourceData = {
            actions: [], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    map, paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.staffInfo = {}
        this.formUserId =''
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(reponsive => {
                const staffObj = reponsive['response']['staff']['map'][success]
                const staffRoles = staffObj['roles']
                let clinicList = []
                this.staffInfo = staffObj
                this.doctor = staffRoles.indexOf('doctor')
                this.cordinator = staffRoles.indexOf('cordinator')
                this.administrator = staffRoles.indexOf('administrator')
                this.confirmListId = staffObj['clinics']
                this.hasPasswordAuthentication = staffObj.passwordAuthentiction
                this.formUserId = this.staffInfo['userId']
                if(this.hasPasswordAuthentication){
                    this.hasPassword = '********'
                } else {
                    this.hasPassword = undefined
                }                
                
                if (this.confirmListId === undefined) {
                    this.confirmListId = []
                    this.confirmList = []
                }
                // this.confirmListId.indexOf(arrClinic._id) >=0) ? true : false
                if (this.arrClinic) {
                    const keys = Object.keys(this.arrClinic)
                    for (let i = 0, len = keys.length; i < len; i++) {
                        // check clinic staff and import arr confirmList
                        const arrClinicStaff = this.confirmListId.indexOf(this.arrClinic[i]['_id']) >= 0 ? this.arrClinic[i]['name'] : null
                        if (arrClinicStaff != null) {
                            clinicList.push(arrClinicStaff)
                        }
                    }
                    this.confirmList = clinicList
                    this.clinicIds = [...this.confirmListId]
                    this.clinics = [...this.confirmList]
                }
                this.staffForm.get('firstName').setValue(staffObj['firstName'])
                this.staffForm.get('familyName').setValue(staffObj['familyName'])
            })
        })
    }

    // click roles doctor
    toggleDoctor(event) {
        this.doctor = (event === -1 ? 0 : -1)
        this.nameDoctor = 'doctor'
    }

    toggleCordinator(event) {
        this.cordinator = (event === -1 ? 0 : -1)
        this.nameCordinator = 'cordinator'
    }

    toggleAdministrator(event) {
        this.administrator = (event === -1 ? 0 : -1)
        this.nameAdministrator = 'administrator'
    }

    checkValidForm(isUpdate=false){
        let isFormvalid = true
        this.form_error_password_valid = this.en['form-error-required']        

        /* Check field name require */ 
        // if (isUpdate && this.staffInfo['firstName'] && !this.staffForm.get('firstName').dirty) {
        //     this.validNameUpdate = true
        // } else {
        //     if (!this.staffForm.value.firstName || this.staffForm.value.firstName.trim() == '') {
        //         this.validNameUpdate = false
        //         isFormvalid = false
        //     } else {
        //         this.validNameUpdate = true
        //     }
        // }

        if (this.staffForm.value.hasPasswordAuthentication) {
            if (this.staffInfo['userId'] && !this.staffForm.get('userId').dirty) {
                this.validUserIdUpdate = true  
                this.isUserIdHalfWidthValid = true  
                isFormvalid = true            
            } else {
                if (!this.staffForm.value.userId || this.staffForm.value.userId.trim() == '') { 
                    this.form_error_userid_valid = this.en['form-error-required']
                    this.validUserIdUpdate = false
                    this.isUserIdHalfWidthValid = true
                    isFormvalid = false
                }
                else {
                    // this.validUserIdUpdate = true
                    const reg = new RegExp(/^[ -00-9:-@A-~]*$/)
                    if (!this.staffForm.value.userId.match(reg)) {
                        this.validUserIdUpdate = false
                        this.isUserIdHalfWidthValid = false
                        isFormvalid = false
                    } else {
                        this.validUserIdUpdate = true
                        this.isUserIdHalfWidthValid = true
                        isFormvalid = true
                    }
                }
            }

            if(isUpdate && !this.staffForm.get('password').dirty){
                if (this.hasPassword) {
                    this.validPassWordUpdate = true
                } else {
                    this.validPassWordUpdate = false
                    isFormvalid = false
                    this.form_error_password_valid = this.en['form-error-required']
                }
            } else {
                if(!this.staffForm.value.password || this.staffForm.value.password.trim() == '') {
                    this.validPassWordUpdate = false
                    isFormvalid = false
                    this.form_error_password_valid = this.en['form-error-required']
                } else {
                const reg = new RegExp(/^[ -00-9:-@A-~]*$/)
                if (!this.staffForm.value.password.match(reg)) {
                    this.validPassWordUpdate = false
                    isFormvalid = false
                    this.form_error_password_valid =this.en['form-error-password-valid']
                } else {
                    this.validPassWordUpdate = true
                }}
            }

            if (this.isUserIdExist) {
                isFormvalid = false
                this.validUserIdUpdate = false
            }

        }
        if(!isFormvalid) {this.checkEnableSave()}
        return isFormvalid
    }

    changeHasPassword(){        
        if(this.staffForm.value.hasPasswordAuthentication){                       
            this.checkUserIdExist()
            if(this.hasPassword) {
                this.stylePassword(this.hasPassword.length)
            } else {
                this.stylePassword(0,true)
            }
            if(!this.formUserId){
                this.validUserIdUpdate = false            
                this.form_error_userid_valid = this.en['form-error-required']
            }
            this.checkEnableSave()
        } else {
            this.isEnableSave = true
        }
    }
    checkUserIdExist() {
        if (this.staffForm.value.hasPasswordAuthentication) {
            if(this.staffForm.get('userId').dirty && this.staffForm.value.userId.trim()==''){
                this.validUserIdUpdate = false
                this.isUserIdHalfWidthValid = true
                this.checkEnableSave()
                this.form_error_userid_valid = this.en['form-error-required']
                return
            }
            else{
                this.validUserIdUpdate = true
                if(!this.staffForm.value.userId || this.staffForm.value.userId.trim() == '') {
                    this.validUserIdUpdate = false
                    this.isUserIdHalfWidthValid = true
                    this.checkEnableSave()
                    return
                } else {
                    // const reg = new RegExp(/^[ -00-9:-@A-~]*$/)
                    const reg = new RegExp(/^[0-9A-Za-z_-]+$/)
                    // if (!this.staffForm.value.userId.match(reg)) {
                    if (!this.staffForm.value.userId.match(reg)) {
                        this.validUserIdUpdate = false
                        this.isUserIdHalfWidthValid = false
                        this.checkEnableSave()
                        return
                    } else {
                        this.validUserIdUpdate = true
                        this.isUserIdHalfWidthValid = true
                        this.checkEnableSave()
                    }
                }
            }
            //check user ID is exist
            if (this.staffForm.get('userId').dirty && this.staffForm.value.userId.trim()!='') {
                this.validUserIdUpdate = true
                if(this.staffForm.value.userId.trim() == this.staffInfo['userId']){
                    this.isUserIdExist = false
                    this.validUserIdUpdate = true
                    this.checkEnableSave()
                    return
                }

                let resourceUrl = 'account/staffExists'
                let resourceData = { organizationId: this.staffForm.value.userId.trim() }
                //
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(res => {
                    //
                        if (res['userIdExists']&& this.staffForm.value.hasPasswordAuthentication) {
                            this.validUserIdUpdate = false
                            this.isUserIdExist =true
                            this.form_error_userid_valid = this.en['form-error-userid-exist']
                        } else {
                            this.isUserIdExist = false
                            this.validUserIdUpdate = true
                            this.form_error_userid_valid = this.en['form-error-required']
                    }
                    this.checkEnableSave()
                })
            })
            }
            

        }
    }

    preSave() {
        let firstName = this.staffForm.value.firstName
        let familyName = this.staffForm.value.familyName
        if ((firstName && firstName.trim() !== '') || (familyName && familyName.trim() !== '')) {
            this.isSaveStaff = true
            this.isEditStaff = true
        } else {
            this.isSaveStaff = false
            this.isEditStaff = false
        }
    }

    // new staff
    createStaff() {

        if (!this.checkValidForm()) {
            return
        }
        let data = {
            firstName : null,
            familyName : null,
            password: null,
            userId: null
        }
        if(this.staffForm.value.firstName){
            data.firstName = this.staffForm.value.firstName.trim()
        }
        if(this.staffForm.value.familyName){
            data.familyName = this.staffForm.value.familyName.trim()
        }
        if(this.staffForm.value.password){
            data.password = this.staffForm.value.password.trim()
        }
        if(this.staffForm.value.userId){
            data.userId = this.staffForm.value.userId.trim()
        }

        this.maxRank += 1
        const resourceData = {
            actions: [{
                type: 'create', collection: 'staff', value: {
                    accessCounter: 0,
                    allowLoginAfter: Date.now(),
                    clinics: this.confirmListId,
                    firstName: data.firstName,
                    familyName: data.familyName,
                    hasPassword: true,
                    password: data.password,
                    passwordAuthentiction: this.staffForm.value.hasPasswordAuthentication,
                    roles: [(this.doctor === 0 ? 'doctor' : ''), (this.cordinator === 0 ? 'cordinator' : ''), (this.administrator === 0 ? 'administrator' : '')], // updateTime:  Date.now(),
                    userId: data.userId,
                    rank: this.maxRank
                },
            }], status: {
                setting: {
                    map: {
                        common: true, alignerMail: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.hiddenNewStaff = 'hidden'
                this._sharedService.emitChangeParent(success['response']['staff']['paths']['{}'])
                this.staffForm.reset()
                this.doctor = undefined
                this.cordinator = undefined
                this.administrator = undefined
                this.hidenModal()
            })
        })
    }

    // update staff
    updateStaff(idStaff) {

        if (!this.checkValidForm(true)) {
            return
        }

        let data = {
            firstName : null,
            familyName : null,
            password: null,
            userId: null
        }
        if(this.staffForm.value.firstName){
            data.firstName = this.staffForm.value.firstName.trim()
        }
        if(this.staffForm.value.familyName){
            data.familyName = this.staffForm.value.familyName.trim()
        }
        if(this.staffForm.value.password){
            data.password = this.staffForm.value.password.trim()
        }
        if(this.staffForm.value.userId){
            data.userId = this.staffForm.value.userId.trim()
        }

        const roles = [(this.doctor >= 0 ? 'doctor' : ''), (this.cordinator >= 0 ? 'cordinator' : ''), (this.administrator >= 0 ? 'administrator' : '')].filter(el => el !== '')
        //
        const valueStaff = {
            accessCounter: 0,
            allowLoginAfter: 1,
            clinics: this.confirmListId,
            firstName: data.firstName,
            familyName: data.familyName,
            password: (this.staffForm.get('password').dirty ? data.password : ''),
            passwordAuthentiction: this.staffForm.value.hasPasswordAuthentication,
            roles: roles, // updateTime:  Date.now(),
            userId: data.userId,
        }
        // remove value null in Value Action
        // for (const key in valueStaff) {
        // 	if (valueStaff[key] === '' || valueStaff[key] === undefined) {
        // 		delete valueStaff[key];
        // 	}
        // }
        const valueData = pickBy(valueStaff, identity)
        valueData.passwordAuthentiction = valueStaff.passwordAuthentiction
        valueData.accessCounter = this.staffInfo['accessCounter']
        valueData.firstName = valueStaff.firstName
        valueData.familyName = valueStaff.familyName
        console.debug(valueData)
        const resourceData = {
            actions: [{
                type: 'update', id: idStaff, collection: 'staff', value: valueData,
            }], status: {
                setting: {
                    map: {
                        common: true, alignerMail: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.hiddenModal = 'hidden'
                this._sharedService.emitChangeParent(success['response']['staff']['paths']['{}'])
                // this.hidenModal();
                this.clinicIds = undefined
                this.clinics = undefined
                this.confirmList = []
                this.confirmListId = []
            })  
        })
    }

    // remove staff
    removeStaff(idStaff) {
       
        const valueStaff = {           
            deleted: true,
        }       
        const valueData = pickBy(valueStaff, identity)

        const resourceData = {
            actions: [{
                type: 'update', id: idStaff, collection: 'staff', value: valueData,
            }], status: {
                setting: {
                    map: {
                        common: true, alignerMail: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }        
        
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.hiddenModal = 'hidden'
                this._sharedService.emitChangeParent(success['response']['staff']['paths']['{}'])
                // this.hidenModal();  
            })
        })

    }

    closeModalClinic() {
        this.validNameUpdate = true
        this.validPassWordUpdate = true
        this.showClinic = 'hidden'
    }

    toggleSelection(ev, id, val) {
        if (ev.target.checked) {
            this.confirmListId.push(id)
            this.confirmList.push(val)
        } else {
            this.confirmListId.splice(this.confirmListId.indexOf(id), 1)
            this.confirmList.splice(this.confirmList.indexOf(val), 1)
        }
    }

    // save clinic
    saveClinic() {
        this.showClinic = 'hidden'
        this.clinicIds = [...this.confirmListId]
        this.clinics = [...this.confirmList]
    }

    // remove password show modal
    removeHasPassword() {
        this.hasPassword = ''
        this.validPassWord()
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    alertLanguage() {
        this.langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/setting/staff/modal-staff-edit.component.ts